import {
  BackButton,
  Container,
  Page,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import {
  useOrganization,
  useTeam,
} from '@foxtrotplatform/platform-micro-site-core';
import { FunctionComponent } from 'react';
import Jotform from 'react-jotform';
import { useAuth } from 'react-oidc-context';

import { DeveloperOrganizationContextProps } from '../common/providers/types';

export const ContactUs: FunctionComponent = (): JSX.Element => {
  const { user } = useAuth();
  const { currentOrg: organization } =
    useOrganization() as DeveloperOrganizationContextProps;
  const { currentTeam } = useTeam();

  return (
    <Page>
      <div>
        <Container size="medium">
          <div>
            <div className="flex flex-row items-center gap-x-3 pb-os1-spacing ">
              <BackButton />
              <PageTitle>Contact Us</PageTitle>
            </div>

            <p>
              We will be glad to help you. Please fill the below form and we
              will get back to you in a timely manner.
            </p>

            <Jotform
              defaults={{
                'name[first]': user?.profile.given_name ?? '',
                'name[last]': user?.profile.family_name ?? '',
                email: user?.profile.email ?? '',
                type: organization?.companyName ?? '',
                teamName: currentTeam?.name ?? '',
              }}
              src="https://form.jotform.com/230395681511152"
            />

            <div className="mt-4">
              <p className="text-sm">By contacting us you agree to OS1's</p>
              <span className="text-sm text-brand-blue bg-transparent">
                <a
                  className="underline"
                  href="https://getos1.com/privacy"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Privacy Policy
                </a>{' '}
                &{' '}
                <a
                  className="underline"
                  href="https://getos1.com/terms"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {' '}
                  Developer Terms & Conditions
                </a>
              </span>
            </div>
          </div>
        </Container>
      </div>
    </Page>
  );
};
